import { Icons, Stack } from '@cast/design-system';

/** Plain text so HeaderCell font (700/12px uppercase) applies like other columns. */
export const RecommendedColumnHeader = () => (
  <Stack direction="row" alignItems="center" gap={4} component="span">
    <Icons.ArrowRight size={16} />
    Recomm.
  </Stack>
);
